module.exports = __webpack_public_path__ + "static/img/7bg_2.c8cb73e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_2.png
// module id = 748
// module chunks = 1